export default __webpack_public_path__ + "static/media/water-2.0678d16a.png";